export const POST_COMMENT = 'POST_COMMENT';
export const POST_COMMENT_PENDING = 'POST_COMMENT_PENDING';
export const POST_COMMENT_FULFILLED = 'POST_COMMENT_FULFILLED';
export const POST_COMMENT_REJECTED = 'POST_COMMENT_REJECTED';

export const POST_COMMENT_RESET_STATE = 'POST_COMMENT_RESET_STATE';
